/* eslint-disable max-lines-per-function */
import React, { useRef, useState, useEffect } from "react";
import { cn } from "tailwind-variants";
import CheckCircleBoldIcon from "assets/icons/check-circle-bold.svg";
import ModalCloseIcon from "assets/icons/modal-close.svg";
import "./CanvaModal.scss";
import { renderList } from "common/vue/render-list";

export default function CanvaModal({ store, ...restProps }) {
  store.useStore();
  const modalRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);

  function continuation() {
    return store.getters["canva/continuation"];
  }
  function designs() {
    return store.getters["canva/designs"];
  }
  function error() {
    return store.getters["canva/error"];
  }
  function loading() {
    return store.getters["canva/loading"];
  }
  function uploading() {
    return store.getters["canva/uploading"];
  }
  function disabled() {
    return !selectedImage || error() || loading() || uploading();
  }
  function moreButtonText() {
    if (loading() && designs().length) {
      return "Loading...";
    }
    return "Load more...";
  }
  function submitButtonText() {
    if (uploading()) {
      return "Uploading";
    }
    return "Proceed";
  }

  async function handleDesignSelect(designId) {
    store.dispatch("canva/selectDesign", designId);
  }

  function fetchDesigns() {
    store.dispatch("canva/fetchDesigns", continuation());
  }

  function getDesignAlt(design) {
    return design?.title || "Untitled Design";
  }
  function getDesignSrc(design) {
    return design?.thumbnail?.url;
  }

  useEffect(() => {
    store.commit("canva/$setModal", modalRef.current);
    fetchDesigns();
  }, []);

  return (
    <div
      {...restProps}
      className={cn("canva-modal modal scope-86c8d61d", restProps.className)}
      ref={modalRef}
      onClick={e => {
        e.stopPropagation();
      }}
      data-testid="canva-modal"
    >
      <div className="canva-modal__modal-box scope-86c8d61d">
        <div className="canva-modal__modal-header scope-86c8d61d">
          <div className="canva-modal__header scope-86c8d61d">
            <h3 className="canva-modal__title scope-86c8d61d">Choose image you want to upload:</h3>
            <button
              className="canva-modal__modal-close scope-86c8d61d"
              type="button"
              data-dismiss="modal"
              data-testid="canva-modal-modal-close"
            >
              <ModalCloseIcon className="scope-86c8d61d" data-testid="canva-modal-close-icon" />
            </button>
          </div>
        </div>
        <div className="canva-modal__modal-body scope-86c8d61d">
          {loading() && !designs().length ? (
            <div className="canva-modal__loading scope-86c8d61d"> Loading... </div>
          ) : error() ? (
            <div className="canva-modal__error scope-86c8d61d">{error()}</div>
          ) : !loading() && !designs().length ? (
            <div className="scope-86c8d61d">No images found</div>
          ) : (
            <div
              className={cn(
                "canva-modal__gallery scope-86c8d61d",
                uploading() && "canva-modal__gallery--uploading"
              )}
            >
              {renderList(designs(), design => (
                <a
                  className={cn(
                    "canva-modal__gallery-item scope-86c8d61d",
                    design.id === selectedImage && "canva-modal__gallery-item--selected"
                  )}
                  key={design.id}
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    setSelectedImage(design.id);
                  }}
                  data-testid="canva-modal-gallery-item"
                >
                  <img
                    className={cn(
                      "canva-modal__gallery-image scope-86c8d61d",
                      !getDesignSrc(design) && "canva-modal__gallery-image--placeholder"
                    )}
                    alt={getDesignAlt(design)}
                    src={getDesignSrc(design)}
                  />
                  {design.id === selectedImage ? (
                    <CheckCircleBoldIcon
                      className="canva-modal__gallery-check scope-86c8d61d"
                      data-testid="canva-modal-gallery-check"
                    />
                  ) : null}
                </a>
              ))}
            </div>
          )}
        </div>
        <div className="canva-modal__actions scope-86c8d61d">
          {continuation() ? (
            <button
              className="canva-modal__action canva-modal__action--secondary scope-86c8d61d"
              disabled={loading() || uploading()}
              type="button"
              onClick={() => {
                fetchDesigns();
              }}
              data-testid="canva-modal-action"
            >
              {moreButtonText()}
            </button>
          ) : null}
          <button
            className="canva-modal__action canva-modal__action--primary scope-86c8d61d"
            disabled={disabled()}
            type="button"
            onClick={() => {
              handleDesignSelect(selectedImage);
            }}
            data-testid="canva-modal-action-1"
          >
            {submitButtonText()}
          </button>
        </div>
      </div>
    </div>
  );
}
